import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { numStringToCss, contrastColor } from '@bit/daviidli.corn-ui.utils';
const StyledCard = styled.div `
	position: relative;
	width: ${p => p.Width};
	background-color: ${p => p.BgColor};
	color: ${p => contrastColor(p.BgColor, '#fff', '#000')};
	overflow: hidden;
	border-radius: 0.5rem;
	border: ${p => {
    if (typeof p.Outline === 'string')
        return `solid 1px ${p.Outline}`;
    if (p.Outline)
        return 'solid 1px #ccc';
    return 'none';
}};

	${p => {
    if (p.Raised) {
        return css `
				box-shadow: 0px 0px 8px -2px rgba(0, 0, 0, 0.6),
					0px 0px 8px -2px rgba(0, 0, 0, 0.1);
			`;
    }
    return '';
}}

	${p => {
    if (p.Hover) {
        const hover = typeof p.Hover === 'string' ? p.Hover : '0.8rem';
        return css `
				transition: all 0.25s ease;
				&:hover {
					box-shadow: 0px 8px 8px -6px rgba(0, 0, 0, 0.6),
						0px 8px 12px -2px rgba(0, 0, 0, 0.15);
					margin-top: -${hover};
					margin-bottom: ${hover};
				}
			`;
    }
    return '';
}}
`;
const Card = ({ children, className, style, outline, hover, raised, bgColor, width }) => (React.createElement(StyledCard, { className: `corn-card ${className || ''}`, Hover: hover, BgColor: bgColor, Outline: outline, Raised: raised, Width: numStringToCss(width), style: style || null }, children));
Card.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.any,
    outline: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    hover: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    raised: PropTypes.bool,
    bgColor: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Card.defaultProps = {
    outline: false,
    hover: false,
    bgColor: '#ddd',
    raised: true,
    width: 'auto'
};
export default Card;
